import { useState, useEffect } from 'react';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { MDBDataTable } from "mdbreact";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { Select, Modal, DatePicker, Switch } from "antd";
import axios from "axios";
import dayjs from 'dayjs';

import Loading from "../Loading";
import { currency, dateFormat, getStoreType } from '../../../../dynamicController';

import { Trans, useTranslation } from "react-i18next";

const { RangePicker } = DatePicker;

const mySwal = withReactContent(Swal);

const STORETYPE = getStoreType()

const GeneralDiscountCodeCard = ({ token, id, role, country, outlets }) => {

    const { t } = useTranslation();

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [code, setCode] = useState("");
    const [start_date, setStartDate] = useState("");
    const [end_date, setEndDate] = useState("");
    const [discount_amount, setDiscountAmount] = useState("");
    const [discount_type, setDiscountType] = useState("");
    const [washer_use, setWasherUse] = useState(false);
    const [dryer_use, setDryerUse] = useState(false);
    const [package_use, setPackageUse] = useState(false);
    const [vending_use, setVendingUse] = useState(false);
    const [detergent_use, setDetergentUse] = useState(false);
    const [carwash_use, setCarwashUse] = useState(false);
    const [redeem_per_user, setRedeemPerUser] = useState("");
    const [redeem_per_day, setRedeemPerDay] = useState("");
    const [pay_and_use, setPayAndUse] = useState(false);
    const [pay_and_use_amount, setPayAndUseAmount] = useState(1);
    const [campaignId, setCampaignId] = useState("");
    const [outletOption, setOutletOption] = useState([])
    const [outletId, setOutletId] = useState([])
    const [outletApplicable, setOutletApplicable] = useState(false)

    useEffect(() => {
        if (outlets) {
            let outletList = []
            for (let i = 0; i < outlets.length; i++) {
                let outletObject = {
                    value: outlets[i].id,
                    label: outlets[i].outlet_fullname
                }
                outletList.push(outletObject)
            }
            setOutletOption(outletList)
        }
    }, [outlets])

    useEffect(() => {
        if (id && role) {
            setLoading(true)
            axios
                .post("/api/admin/setting/getCampaign", { id, role }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {
                    setData(res.data);
                    setLoading(false);
                })
                .catch(err => {
                    setLoading(false);
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                });
        }
    }, [id, role])

    const handleDate = dates => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
    };

    const hideModal = () => {
        setCode("");
        setStartDate("");
        setEndDate("");
        setDiscountAmount("");
        setDiscountType("");
        setWasherUse(false);
        setDryerUse(false);
        setPackageUse(false);
        setVendingUse(false);
        setDetergentUse(false);
        setCarwashUse(false);
        setRedeemPerUser("");
        setRedeemPerDay("");
        setPayAndUse(false);
        setPayAndUseAmount(1);
        setCampaignId("");
        setOutletId([]);
        setOutletApplicable(false);
        setShowModal(false);
    }

    const addCampaignCode = () => {
        setCode("");
        setStartDate("");
        setEndDate("");
        setDiscountAmount("");
        setDiscountType("");
        setWasherUse(false);
        setDryerUse(false);
        setPackageUse(false);
        setVendingUse(false);
        setDetergentUse(false);
        setCarwashUse(false);
        setRedeemPerUser("");
        setRedeemPerDay("");
        setPayAndUse(false);
        setPayAndUseAmount(1);
        setCampaignId("");
        setOutletId([]);
        setOutletApplicable(false);
        setShowModal(true);
    }

    const editCampaignCode = (campaignId) => {
        const selectedCampaign = data.filter(data => data.id === campaignId)[0]
        setCode(selectedCampaign.code);
        setStartDate(new Date(selectedCampaign.start_date));
        setEndDate(new Date(selectedCampaign.end_date));
        setDiscountAmount(selectedCampaign.discount_amount);
        setDiscountType(selectedCampaign.discount_type);
        setWasherUse(selectedCampaign.washer_use);
        setDryerUse(selectedCampaign.dryer_use);
        setPackageUse(selectedCampaign.package_use);
        setVendingUse(selectedCampaign.vending_use);
        setDetergentUse(selectedCampaign.detergent_use);
        setCarwashUse(selectedCampaign.carwash_use);
        setRedeemPerUser(selectedCampaign.redeem_per_user);
        setRedeemPerDay(selectedCampaign.redeem_per_day);
        setPayAndUse(selectedCampaign.pay_and_use);
        setPayAndUseAmount(selectedCampaign.pay_and_use_amount);
        setCampaignId(selectedCampaign.id);
        let outletRules = selectedCampaign.rules.filter(rule => rule.type === "Outlet")
        if (outletRules.length > 0) {
            setOutletId(outletRules.map(rule => rule.outletId))
            setOutletApplicable(outletRules[0].applicable)
        } else {
            setOutletId([])
            setOutletApplicable(false)
        }
        setShowModal(true);
    }

    const editCampaign = (e) => {
        e.preventDefault();

        if (!washer_use && !dryer_use && !package_use && !vending_use && !detergent_use && !carwash_use) {
            mySwal.fire(t("Missing Field"), t("Please select can be used for which type of transaction"), "info");
        } else if (!start_date && !end_date) {
            mySwal.fire(t("Missing Field"), t("Please fill in the start date and end date"), "info");
        } else if (parseFloat(discount_amount) <= 0) {
            mySwal.fire(t("Missing Field"), t("Discount amount should be more than 0"), "info");
        } else if (parseInt(redeem_per_user) <= 0) {
            mySwal.fire(t("Missing Field"), t("Redeem per user should be more than 0"), "info");
        } else if (parseInt(redeem_per_day) <= 0) {
            mySwal.fire(t("Missing Field"), t("Redeem per day should be more than 0"), "info");
        } else {
            setLoading(true);

            let rule = []

            if (outletId.length > 0) {
                for (let i = 0; i < outletId.length; i++) {
                    rule.push({
                        type: "Outlet",
                        applicable: outletApplicable,
                        outletId: outletId[i]
                    })
                }
            }

            const sendThis = {
                id: campaignId,
                start_date: dateFormat(start_date),
                end_date: dateFormat(end_date),
                discount_amount,
                discount_type,
                washer_use,
                dryer_use,
                package_use,
                vending_use,
                detergent_use,
                carwash_use,
                redeem_per_user,
                redeem_per_day,
                pay_and_use,
                pay_and_use_amount,
                rule,
            }

            axios
                .post("/api/admin/setting/editCampaign", sendThis, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {

                    axios
                        .post("/api/admin/setting/getCampaign", { id, role }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                        .then(res => {
                            setData(res.data);
                            setShowModal(false);
                            setLoading(false);
                            mySwal.fire(t("Success"), t("Your discount code have edited successfully"), "success")
                        })
                        .catch(err => {
                            setLoading(false);
                            mySwal.fire(t("Error"), t(err.response.data.error), "error")
                        });
                })
                .catch(err => {
                    setLoading(false);
                    mySwal.fire(t("Error"), t(err.response.data.error), "error")
                });
        }
    }

    const addCampaign = (e) => {
        e.preventDefault();

        if (!washer_use && !dryer_use && !package_use && !vending_use && !detergent_use && !carwash_use) {
            mySwal.fire(t("Missing Field"), t("Please select can be used for which type of transaction"), "info");
        } else if (!start_date && !end_date) {
            mySwal.fire(t("Missing Field"), t("Please fill in the start date and end date"), "info");
        } else if (parseFloat(discount_amount) <= 0) {
            mySwal.fire(t("Missing Field"), t("Discount amount should be more than 0"), "info");
        } else if (parseInt(redeem_per_user) <= 0) {
            mySwal.fire(t("Missing Field"), t("Redeem per user should be more than 0"), "info");
        } else if (parseInt(redeem_per_day) <= 0) {
            mySwal.fire(t("Missing Field"), t("Redeem per day should be more than 0"), "info");
        } else {
            setLoading(true);

            let rule = []

            if (outletId.length > 0) {
                for (let i = 0; i < outletId.length; i++) {
                    rule.push({
                        type: "Outlet",
                        applicable: outletApplicable,
                        outletId: outletId[i]
                    })
                }
            }

            const sendThis = {
                id,
                role,
                code,
                start_date: dateFormat(start_date),
                end_date: dateFormat(end_date),
                discount_amount,
                discount_type,
                washer_use,
                dryer_use,
                package_use,
                vending_use,
                detergent_use,
                carwash_use,
                redeem_per_user,
                redeem_per_day,
                pay_and_use,
                pay_and_use_amount,
                rule,
            }

            axios
                .post("/api/admin/setting/createCampaign", sendThis, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {

                    axios
                        .post("/api/admin/setting/getCampaign", { id, role }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                        .then(res => {
                            setLoading(false);
                            setData(res.data);
                            setShowModal(false)
                            mySwal.fire(t("Success"), t("Your discount code have added successfully"), "success")
                        })
                        .catch(err => {
                            setLoading(false);
                            mySwal.fire(t("Error"), t(err.response.data.error), "error")
                        });
                })
                .catch(err => {
                    setLoading(false);
                    mySwal.fire(t("Error"), t(err.response.data.error), "error")
                });
        }
    }

    const deleteCampaign = campaignId => {
        mySwal
            .fire({
                title: t("Confirmation"),
                text: t("Delete this entry?"),
                icon: "question",
                showCancelButton: true,
                cancelButtonText: t("No"),
                confirmButtonText: t("Yes")
            })
            .then(click => {
                if (click.isConfirmed && click.value) {
                    setLoading(true);

                    axios
                        .post("/api/admin/setting/deleteCampaign", { id: campaignId }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                        .then(res => {

                            axios
                                .post("/api/admin/setting/getCampaign", { id, role }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                                .then(res => {
                                    setData(res.data);
                                    setLoading(false);
                                    mySwal.fire(t("Success"), t("Your discount code have deleted successfully"), "success")
                                })
                                .catch(err => {
                                    setLoading(false);
                                    mySwal.fire(t("Error"), t(err.response.data.error), "error")
                                });
                        })
                        .catch(err => {
                            setLoading(false);
                            mySwal.fire(t("Error"), t(err.response.data.error), "error")
                        });
                }
            });
    }

    let tableData = {
        columns: [
            {
                label: t("Created Date"),
                field: "createdAt",
                sort: "asc"
            },
            {
                label: t("Discount code"),
                field: "code",
                sort: "asc"
            },
            {
                label: t("Start Date"),
                field: "start_date",
                sort: "asc"
            },
            {
                label: t("End Date"),
                field: "end_date",
                sort: "asc"
            },
            {
                label: t("Redeem Per User"),
                field: "redeem_per_user",
                sort: "asc"
            },
            {
                label: t("Redeem Per Day"),
                field: "redeem_per_day",
                sort: "asc"
            },
            {
                label: t("Discount Type"),
                field: "discount_type",
                sort: "asc"
            },
            {
                label: t("Discount Amount"),
                field: "discount_amount",
                sort: "asc"
            },
            {
                label: t("Washer Use"),
                field: "washer_use",
                sort: "asc"
            },
            {
                label: t("Dryer Use"),
                field: "dryer_use",
                sort: "asc"
            },
            {
                label: t("Package Use"),
                field: "package_use",
                sort: "asc"
            },
            {
                label: t("Vending Use"),
                field: "vending_use",
                sort: "asc"
            },
            {
                label: t("Detergent Use"),
                field: "detergent_use",
                sort: "asc"
            },
            {
                label: t("Car Wash Use"),
                field: "carwash_use",
                sort: "asc"
            },
            {
                label: t("Pay And Use Code"),
                field: "pay_and_use",
                sort: "asc"
            },
            {
                label: `${t("Minimum Transaction Amount To Use Code")} (${currency(country)})`,
                field: "pay_and_use_amount",
                sort: "asc"
            },
            {
                label: t("Action"),
                field: "action"
            }
        ],
        rows: []
    };

    if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
            const dataObject = {
                createdAt: data[i].createdAt,
                code: data[i].code,
                start_date: data[i].start_date,
                end_date: data[i].end_date,
                redeem_per_user: data[i].redeem_per_user,
                redeem_per_day: data[i].redeem_per_day,
                discount_type: data[i].discount_type === "Flat" ? `${data[i].discount_type} (${currency(country)})` : `${data[i].discount_type} (%)`,
                discount_amount: data[i].discount_amount,
                washer_use: data[i].washer_use ? t("Yes") : t("No"),
                dryer_use: data[i].dryer_use ? t("Yes") : t("No"),
                package_use: data[i].package_use ? t("Yes") : t("No"),
                vending_use: data[i].vending_use ? t("Yes") : t("No"),
                detergent_use: data[i].detergent_use ? t("Yes") : t("No"),
                carwash_use: data[i].carwash_use ? t("Yes") : t("No"),
                pay_and_use: data[i].pay_and_use ? t("Yes") : t("No"),
                pay_and_use_amount: data[i].pay_and_use_amount,
                action: (
                    <div>
                        <i className="bi bi-pencil-square" onClick={() => editCampaignCode(data[i].id)}></i>
                        <i className="bi bi-trash3-fill ms-3" onClick={() => deleteCampaign(data[i].id)}></i>
                    </div>
                )
            }
            tableData.rows.push(dataObject);
        }
    }

    return (
        <div>
            <div className="card">
                <div className="card-header d-flex justify-content-between">
                    <h5 className="card-title">{t("General Discount Code")}</h5>

                    <button className="btn btn-primary" type="button" onClick={e => addCampaignCode()}>
                        {t("Add Discount Code")}
                    </button>
                </div>

                <div className="card-body">
                    <div>
                        {
                            loading ? <Loading /> :
                                data.length > 0 ? <MDBDataTable data={tableData} noBottomColumns striped hover responsive bordered /> :
                                    (
                                        <div className="text-center">
                                            <h1> - {t("No Discount Code")} - </h1>
                                        </div>
                                    )
                        }
                    </div>
                </div>
            </div>

            <Modal
                title={campaignId ? t("Edit Discount Code") : t("Add Discount Code")}
                open={showModal}
                footer={null}
                onCancel={e => hideModal()}
                centered
            >
                <div>
                    <form onSubmit={campaignId ? editCampaign : addCampaign}>
                        {
                            campaignId ? (
                                <div className="form-group text-left">
                                    <label htmlFor="code">{t("Discount Code")}</label>
                                    <input type="text" id="code" name="code" value={code} className="form-control browser-default" required readOnly />
                                </div>
                            ) : (
                                <div className="form-group text-left">
                                    <label htmlFor="code">{t("Discount Code")}</label>
                                    <input type="text" id="code" name="code" value={code} className="form-control browser-default" onChange={e => setCode(e.target.value.toUpperCase())} required />
                                </div>
                            )
                        }

                        <div className="form-group text-left">
                            <label htmlFor="date">{t("Select Period")}: </label>
                            <RangePicker
                                id="date"
                                name="date"
                                placeholder={[t("Start date"), t("End date")]}
                                onChange={handleDate}
                                style={{ width: '100%' }}
                                value={start_date && end_date ? [dayjs(start_date), dayjs(end_date)] : []}
                            />
                        </div>

                        <div className="form-group text-left">
                            <label htmlFor="redeem_per_user">{t("Redeem per user")} <small>({t("How many times the discount code can be used for each user")})</small> : </label>
                            <input type="number" className="form-control browser-default" id="redeem_per_user" name="redeem_per_user" value={redeem_per_user} onChange={e => setRedeemPerUser(e.target.value)} min="1" step="1" required />
                        </div>

                        <div className="form-group text-left">
                            <label htmlFor="redeem_per_day">{t("Redeem per day")} <small>({t("How many times the discount code can be used in one day")})</small> : </label>
                            <input type="number" className="form-control browser-default" id="redeem_per_day" name="redeem_per_day" value={redeem_per_day} onChange={e => setRedeemPerDay(e.target.value)} min="1" step="1" required />
                        </div>

                        <div className="form-group text-left">
                            <label htmlFor="discount_type">{t("Discount Type")} : </label>
                            <select className="browser-default form-select" id="discount_type" name="discount_type" value={discount_type} onChange={e => setDiscountType(e.target.value)} required>
                                <option value="" disabled>{t("Select a discount type")}</option>
                                <option value="Flat">{t("Flat")} (- {currency(country)})</option>
                                <option value="Rate">{t("Rate")} (- %)</option>
                            </select>
                        </div>

                        <div className="form-group text-left">
                            <label htmlFor="discount_amount">{t("Discount Amount")} : <small>{discount_type === "Flat" ? `(${currency(country)})` : discount_type === "Rate" ? "(%)" : ""}</small></label>
                            <input type="number" className="form-control browser-default" id="discount_amount" name="discount_amount" value={discount_amount} onChange={e => setDiscountAmount(e.target.value)} min="0" step="0.01" required />
                        </div>

                        <div className="form-group mt-5">
                            <div className="d-flex">
                                <Switch value={outletApplicable} onChange={() => setOutletApplicable(!outletApplicable)} />
                                <p className="ps-2">{outletApplicable ? t("Only applicable to selected outlet") : t("Applicable to all the outlets except selected outlet")}</p>
                            </div>

                            <label htmlFor="outletId">{t("Outlet")} <small>({t("If applicable to all the outlet, leave it blank")})</small></label>
                            <Select
                                id="outletId"
                                name="outletId"
                                mode="multiple"
                                allowClear
                                style={{ width: '100%' }}
                                placeholder={t("Select Outlet")}
                                showSearch
                                optionFilterProp="label"
                                onChange={(value) => setOutletId(value)}
                                options={outletOption}
                                value={outletId}
                            />
                        </div>

                        <div className="text-center">
                            <div style={{ maxWidth: "400px", margin: "auto", display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                                <div className="form-group">
                                    <label>
                                        <input type="checkbox" id="pay_and_use" name="pay_and_use" checked={pay_and_use} onChange={e => setPayAndUse(!pay_and_use)} />
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>
                                                    {t("If ticked, the user only can use the discount code after make a transaction")}
                                                </Tooltip>
                                            }
                                        >
                                            <span>{t("Pay And Use Code")}</span>
                                        </OverlayTrigger>
                                    </label>
                                </div>

                                <div className="form-group">
                                    <label>
                                        <input type="checkbox" id="package_use" name="package_use" checked={package_use} onChange={e => setPackageUse(!package_use)} />
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>
                                                    {t("If ticked, the discount code can apply to Drop n Go transaction")}
                                                </Tooltip>
                                            }
                                        >
                                            <span>{t("Package Use")}</span>
                                        </OverlayTrigger>
                                    </label>
                                </div>
                            </div>

                            <div style={{ maxWidth: "400px", margin: "auto", display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                                <div className="form-group">
                                    <label>
                                        <input type="checkbox" id="washer_use" name="washer_use" checked={washer_use} onChange={e => setWasherUse(!washer_use)} />
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>
                                                    {t("If ticked, the discount code can apply to washer machine transaction")}
                                                </Tooltip>
                                            }
                                        >
                                            <span>{t("Washer Use")}</span>
                                        </OverlayTrigger>
                                    </label>
                                </div>

                                <div className="form-group">
                                    <label>
                                        <input type="checkbox" id="dryer_use" name="dryer_use" checked={dryer_use} onChange={e => setDryerUse(!dryer_use)} />
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>
                                                    {t("If ticked, the discount code can apply to dryer machine transaction")}
                                                </Tooltip>
                                            }
                                        >
                                            <span>{t("Dryer Use")}</span>
                                        </OverlayTrigger>
                                    </label>
                                </div>
                            </div>

                            <div style={{ maxWidth: "400px", margin: "auto", display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                                <div className="form-group">
                                    <label>
                                        <input type="checkbox" id="vending_use" name="vending_use" checked={vending_use} onChange={e => setVendingUse(!vending_use)} />
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>
                                                    {t("If ticked, the discount code can apply to vending machine transaction")}
                                                </Tooltip>
                                            }
                                        >
                                            <span>{t("Vending Use")}</span>
                                        </OverlayTrigger>
                                    </label>
                                </div>

                                <div className="form-group">
                                    <label>
                                        <input type="checkbox" id="detergent_use" name="detergent_use" checked={detergent_use} onChange={e => setDetergentUse(!detergent_use)} />
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>
                                                    {t("If ticked, the discount code can apply to detergent vending machine transaction")}
                                                </Tooltip>
                                            }
                                        >
                                            <span>{t("Detergent Use")}</span>
                                        </OverlayTrigger>
                                    </label>
                                </div>

                                <div className="form-group">
                                    <label>
                                        <input type="checkbox" id="carwash_use" name="carwash_use" checked={carwash_use} onChange={e => setCarwashUse(!carwash_use)} />
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>
                                                    {t("If ticked, the discount code can apply to car wash transaction")}
                                                </Tooltip>
                                            }
                                        >
                                            <span>{t("Car Wash Use")}</span>
                                        </OverlayTrigger>
                                    </label>
                                </div>
                            </div>
                        </div>

                        {
                            pay_and_use ? (
                                <div className="form-group text-left">
                                    <label htmlFor="pay_and_use_amount">{t("Minimum Payment Amount To Use Discount Code")} : <small>({currency(country)})</small></label>
                                    <input type="number" className="form-control browser-default" id="pay_and_use_amount" name="pay_and_use_amount" value={pay_and_use_amount} onChange={e => setPayAndUseAmount(e.target.value)} min="0" step="0.01" required />
                                </div>
                            ) : null
                        }

                        <p className="p-0 m-0"><small>* {t("The user enter the discount code")} {code ? `(${code})` : ""} {t("in the payment page will get")} {discount_type === "Flat" ? currency(country) : ""}{discount_amount}{discount_type === "Rate" ? "%" : ""} {t("discount")}</small></p>
                        {
                            start_date && end_date
                                ? <p className="p-0 m-0">
                                    <small>*
                                        <Trans i18nKey="The discount code only can be used start from {{ start_date }} until {{ end_date }}">
                                            The discount code only can be used start from {{ start_date: new Date(start_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) }} until {{ end_date: new Date(end_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) }}
                                        </Trans>
                                    </small>
                                </p>
                                : ""
                        }
                        {
                            redeem_per_user
                                ? <p className="p-0 m-0">
                                    <small>*
                                        <Trans i18nKey="Every user only can use the discount code {{ redeem_per_user }} times">
                                            Every user only can use the discount code {{ redeem_per_user }} times
                                        </Trans>
                                    </small>
                                </p>
                                : ""
                        }
                        {
                            redeem_per_day
                                ? <p className="p-0 m-0">
                                    <small>*
                                        <Trans i18nKey="Only {{ redeem_per_day }} transactions can use the discount code in one day" count={parseFloat(redeem_per_day)}>
                                            Only {{ redeem_per_day }} transactions can use the discount code in one day
                                        </Trans>
                                    </small>
                                </p>
                                : ""
                        }
                        {washer_use && !dryer_use && !package_use && !vending_use && !detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code only can be used for washer machine")}</small></p> : ""}
                        {!washer_use && dryer_use && !package_use && !vending_use && !detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code only can be used for dryer machine")}</small></p> : ""}
                        {!washer_use && !dryer_use && package_use && !vending_use && !detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code only can be used for Drop n Go transaction")}</small></p> : ""}
                        {!washer_use && !dryer_use && !package_use && vending_use && !detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code only can be used for vending machine transaction")}</small></p> : ""}
                        {!washer_use && !dryer_use && !package_use && !vending_use && detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code only can be used for detergent vending machine transaction")}</small></p> : ""}
                        {!washer_use && !dryer_use && !package_use && !vending_use && !detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code only can be used for car wash transaction")}</small></p> : ""}

                        {washer_use && dryer_use && !package_use && !vending_use && !detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer or dryer machine")}</small></p> : ""}
                        {washer_use && !dryer_use && package_use && !vending_use && !detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine or Drop n Go transaction")}</small></p> : ""}
                        {washer_use && !dryer_use && !package_use && vending_use && !detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine or vending machine transaction")}</small></p> : ""}
                        {washer_use && !dryer_use && !package_use && !vending_use && detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine or detergent vending machine transaction")}</small></p> : ""}
                        {washer_use && !dryer_use && !package_use && !vending_use && !detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine or car wash transaction")}</small></p> : ""}

                        {!washer_use && dryer_use && package_use && !vending_use && !detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for dryer machine or Drop n Go transaction")}</small></p> : ""}
                        {!washer_use && dryer_use && !package_use && vending_use && !detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for dryer machine or vending machine transaction")}</small></p> : ""}
                        {!washer_use && dryer_use && !package_use && !vending_use && detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for dryer machine or detergent vending machine transaction")}</small></p> : ""}
                        {!washer_use && dryer_use && !package_use && !vending_use && !detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for dryer machine or car wash transaction")}</small></p> : ""}

                        {!washer_use && !dryer_use && package_use && vending_use && !detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for vending machine or Drop n Go transaction")}</small></p> : ""}
                        {!washer_use && !dryer_use && package_use && !vending_use && detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for detergent vending machine or Drop n Go transaction")}</small></p> : ""}
                        {!washer_use && !dryer_use && package_use && !vending_use && !detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for car wash or Drop n Go transaction")}</small></p> : ""}

                        {!washer_use && !dryer_use && !package_use && vending_use && detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for vending machine or detergent vending machine transaction")}</small></p> : ""}
                        {!washer_use && !dryer_use && !package_use && vending_use && !detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for vending machine or car wash transaction")}</small></p> : ""}

                        {!washer_use && !dryer_use && !package_use && !vending_use && detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for detergent vending machine or car wash transaction")}</small></p> : ""}

                        {washer_use && dryer_use && package_use && !vending_use && !detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine, dryer machine or Drop n Go transaction")}</small></p> : ""}
                        {washer_use && dryer_use && !package_use && vending_use && !detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine, dryer machine or vending machine transaction")}</small></p> : ""}
                        {washer_use && dryer_use && !package_use && !vending_use && detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine, dryer machine or detergent vending machine transaction")}</small></p> : ""}
                        {washer_use && dryer_use && !package_use && !vending_use && !detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine, dryer machine or car wash transaction")}</small></p> : ""}

                        {washer_use && !dryer_use && package_use && vending_use && !detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine, vending machine or Drop n Go transaction")}</small></p> : ""}
                        {washer_use && !dryer_use && package_use && !vending_use && detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine, detergent vending machine or Drop n Go transaction")}</small></p> : ""}
                        {washer_use && !dryer_use && package_use && !vending_use && !detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine, car wash or Drop n Go transaction")}</small></p> : ""}

                        {washer_use && !dryer_use && !package_use && vending_use && detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine, vending machine or detergent vending machine transaction")}</small></p> : ""}
                        {washer_use && !dryer_use && !package_use && vending_use && !detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine, vending machine or car wash transaction")}</small></p> : ""}

                        {washer_use && !dryer_use && !package_use && !vending_use && detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine, detergent vending machine or car wash transaction")}</small></p> : ""}

                        {!washer_use && dryer_use && package_use && vending_use && !detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for dryer machine, vending machine or Drop n Go transaction")}</small></p> : ""}
                        {!washer_use && dryer_use && package_use && !vending_use && detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for dryer machine, detergent vending machine or Drop n Go transaction")}</small></p> : ""}
                        {!washer_use && dryer_use && package_use && !vending_use && !detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for dryer machine, car wash or Drop n Go transaction")}</small></p> : ""}
                        {!washer_use && dryer_use && !package_use && vending_use && detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for dryer machine, vending machine or detergent vending machine transaction")}</small></p> : ""}
                        {!washer_use && dryer_use && !package_use && vending_use && !detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for dryer machine, vending machine or car wash transaction")}</small></p> : ""}
                        {!washer_use && dryer_use && !package_use && !vending_use && detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for dryer machine, detergent vending machine or car wash transaction")}</small></p> : ""}

                        {!washer_use && !dryer_use && package_use && vending_use && detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for vending machine, detergent vending machine or Drop n Go transaction")}</small></p> : ""}
                        {!washer_use && !dryer_use && package_use && vending_use && !detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for vending machine, car wash or Drop n Go transaction")}</small></p> : ""}
                        {!washer_use && !dryer_use && package_use && !vending_use && detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for detergent vending machine, car wash or Drop n Go transaction")}</small></p> : ""}
                        {!washer_use && !dryer_use && !package_use && vending_use && detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for vending machine, detergent vending machine or car wash transaction")}</small></p> : ""}

                        {washer_use && dryer_use && package_use && vending_use && !detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine, dryer machine, vending machine or Drop n Go transaction")}</small></p> : ""}
                        {washer_use && dryer_use && !package_use && vending_use && detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine, dryer machine, vending machine or detergent vending machine transaction")}</small></p> : ""}
                        {washer_use && dryer_use && !package_use && vending_use && !detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine, dryer machine, vending machine or car wash transaction")}</small></p> : ""}
                        {washer_use && dryer_use && !package_use && !vending_use && detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine, dryer machine, detergent vending machine or car wash transaction")}</small></p> : ""}
                        {washer_use && !dryer_use && package_use && vending_use && detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine, vending machine, detergent vending machine or Drop n Go transaction")}</small></p> : ""}
                        {washer_use && !dryer_use && package_use && vending_use && !detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine, vending machine, car wash or Drop n Go transaction")}</small></p> : ""}
                        {washer_use && !dryer_use && !package_use && vending_use && detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine, vending machine, detergent vending machine or car wash transaction")}</small></p> : ""}
                        {!washer_use && dryer_use && package_use && vending_use && detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for dryer machine, vending machine, detergent vending machine or Drop n Go transaction")}</small></p> : ""}
                        {!washer_use && dryer_use && package_use && vending_use && !detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for dryer machine, vending machine, car wash or Drop n Go transaction")}</small></p> : ""}
                        {!washer_use && dryer_use && package_use && !vending_use && detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for dryer machine, detergent vending machine, car wash machine or Drop n Go transaction")}</small></p> : ""}
                        {!washer_use && dryer_use && !package_use && vending_use && detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for dryer machine, vending machine, detergent vending machine or car wash transaction")}</small></p> : ""}
                        {!washer_use && !dryer_use && package_use && vending_use && detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for vending machine, detergent vending machine, car wash or Drop n Go transaction")}</small></p> : ""}

                        {washer_use && dryer_use && package_use && vending_use && detergent_use && !carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine or Drop n Go transaction")}</small></p> : ""}
                        {washer_use && dryer_use && package_use && vending_use && !detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine, dryer machine, vending machine, car wash or Drop n Go transaction")}</small></p> : ""}
                        {washer_use && dryer_use && package_use && !vending_use && detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine, dryer machine, detergent vending machine, car wash or Drop n Go transaction")}</small></p> : ""}
                        {washer_use && dryer_use && !package_use && vending_use && detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine or car wash transaction")}</small></p> : ""}
                        {washer_use && !dryer_use && package_use && vending_use && detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction")}</small></p> : ""}
                        {!washer_use && dryer_use && package_use && vending_use && detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction")}</small></p> : ""}
                        {washer_use && dryer_use && package_use && vending_use && detergent_use && carwash_use ? <p className="p-0 m-0"><small>* {t("The discount code can be used for washer machine, dryer machine, vending machine, detergent vending machine, car wash or Drop n Go transaction")}</small></p> : ""}
                        {
                            pay_and_use
                                ? <p className="p-0 m-0">
                                    <small>*
                                        <Trans i18nKey="The discount code only can be used after user spending {{ currency }} {{ pay_and_use_amount }}">
                                            The discount code only can be used after user spending {{ currency: currency(country) }} {{ pay_and_use_amount }}
                                        </Trans>
                                    </small>
                                </p>
                                : null
                        }

                        <div className="text-center pt-3">
                            {loading ? (
                                <div className="text-center">
                                    <div className={`spinner-border text-${STORETYPE === "cuci" ? "warning" : "primary"}`} role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            ) : <input type="submit" value={campaignId ? t("Edit Discount Code") : t("Add Discount Code")} className="btn btn-primary mx-2" />}
                            <button type="button" className="btn btn-secondary" onClick={e => hideModal()}>
                                {t("Close")}
                            </button>
                        </div>
                    </form>
                </div>
            </Modal>
        </div>
    );
};

export default GeneralDiscountCodeCard;